import type {ReactAction} from '@netx/core/bootstrap';
import {faPencilAlt} from '@fortawesome/pro-solid-svg-icons';
import {type ICategory} from '@netx/core-category-next/schema';
import {canEditCategory} from '../enablers';
import {CategoryActionLabel} from '../locales';
import {CATEGORY_EVENT} from './constants';

export const categoryActionEditIcon = faPencilAlt;

/**
 * Edit category
 * @param params
 * @returns Action
 */
export const categoryActionEdit = (
	category?: ICategory,
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'category-edit',
	cb: () => dispatcher.trigger(CATEGORY_EVENT.EDIT, category),
	enableTest: () => canEditCategory(category),
	icon: categoryActionEditIcon,
	get label() {
		return CategoryActionLabel.EDIT;
	},
	...params,
});

export default categoryActionEdit;
